/**
 * Route definition for /physical-goods
 * Renders the PhysicalGoodsContainer component (Physical Goods placeholder page).
 *
 * @module routes/physical-goods
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import PhysicalGoodsContainer from "@/containers/PhysicalGoods";

export const Route = createFileRoute('/$locale/physical-goods')({
  component: PhysicalGoods,
})

/**
 * Physical Goods page component.
 * Displays a work-in-progress placeholder for the physical goods marketplace feature.
 *
 * @returns {React.ReactElement}
 */
function PhysicalGoods() {

    return (
        <>
            <PhysicalGoodsContainer/>
        </>
    );
}